import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "ion-padding",
  style: {"color":"var(--ion-color-primary)"}
}

import { CustomElement } from "@/types";
import { executeLink, getCurrentLanguage, getIcon } from "@/utils";
import { IonHeader, IonToolbar, IonGrid, IonRow, IonCol } from "@ionic/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AnnouncementViewer',
  props: {
  title: {
    type: String,
    required: true,
  },
  id: {
    type: Number,
    required: true,
  },
},
  emits: ["signal_event", "close"],
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;

const language = getCurrentLanguage();




const elements: {
  [key: string]: CustomElement;
} = {
  close: {
    id: "close",
    type: "icon",
    linkType: "event",
    content: {
      event: "close",
      icon: getIcon("close"),
    },
  },
  title: {
    id: "title",
    type: "title",
    content: props.title,
  },
};

const content: CustomElement = (
  ([__temp,__restore] = _withAsyncContext(() => executeLink(
  "/v1/announcements/" + props.id,
  (response) => {
    return {
      id: "content",
      type: "html",
      content: response.data.data[`${language}_message`],
    };
  },
  () => {
    return {
      id: "content",
      type: "html",
      content: "",
    };
  }
))),
  __temp = await __temp,
  __restore(),
  __temp
);

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!

  return (_openBlock(), _createBlock(_unref(IonHeader), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonToolbar), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), { class: "ion-text-center ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ionic_element, {
                        element: elements.title
                      }, null, 8, ["element"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCol), { size: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ionic_element, {
                        element: elements.close,
                        onSignal_event: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                      }, null, 8, ["element"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ionic_element, { element: _unref(content) }, null, 8, ["element"])
      ])
    ]),
    _: 1
  }))
}
}

})